<template>
  <section class="nurse">
   <div class="nurse_func">
    <p>Данный функционал будет добавлен в проект в ближайшее время.</p>
    <p>Следите за обновлениями проекта.</p>
  </div>
  <div class="help_block"></div>
</section>
</template>
<script>
  export default {
   name: 'Nurse'
 }
</script>

<style>
  .nurse {
    height: 100%;
  }

  .nurse_func {
    margin-top: 100px;
    padding: 0 10px;
  }

  .nurse_func p {
    color: #7f7f7f;
    font-size: 18px;
    text-align: center;
  }

  .nurse_func p:first-child {
    margin-bottom: 30px;
  }

  .help_block {
    height: 50px;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// Nurse.vue?d3c732b4